import React from 'react';
import { Row, Col, Button, FormControl } from 'react-bootstrap';

const constants = {
    OI_TYPE: 'oi',
    DESIGNATED_GC: 'designatedContractors',
    VALID_BASE_COVERAGES: ['standard']
};

export class DesignatedGeneralContractor extends React.Component {
    constructor(props) {
        super(props);
        this.MAX_ROWS = 1;
        this.type = this.props.type;

        this.state = {
            gcNameList: setGCNameList(this.props.submission.ratings[this.type], this.props.coverage, this.type)
        };

        this.onBlurHandler = this.onBlurHandler.bind(this);
        this.addListRow = this.addListRow.bind(this);
        this.deleteListRow = this.deleteListRow.bind(this);
    }

    componentDidUpdate(prevProps) {
        const newDesignatedGC = this.props.pricingValues.designatedContractors;
        const prevDesignatedGC = prevProps.pricingValues.designatedContractors;
        // check for change in designatedContractor
        if (JSON.stringify(newDesignatedGC) !== JSON.stringify(prevDesignatedGC)) {
            const gcNameIsValid = designatedGCCompleted(newDesignatedGC);
            // clear u658ContractorName if has a value and is invalid
            if (this.state.gcNameList.length > 0 && !gcNameIsValid) {
                this.setState(
                    {
                        gcNameList: []
                    },
                    () => {
                        if (this.props.pricingValues.u658ContractorName !== undefined) {
                            this.props.onBlurHandler({
                                u658ContractorName: ''
                            });
                        }
                    }
                );
            }
        }
    }

    onBlurHandler(event, key) {
        const { gcNameList } = this.state;
        const updatedGCNameList = gcNameList.map(item => {
            if (item.key === key) {
                return {
                    ...item,
                    text: event.target.value
                };
            }
            return item;
        });
        this.setState({ gcNameList: updatedGCNameList });
        const gcName = updatedGCNameList.length > 0 ? updatedGCNameList[0].text : '';
        this.props.onBlurHandler({
            u658ContractorName: gcName
        });
    }

    addListRow() {
        let key = 1;
        if (Array.isArray(this.state.gcNameList) && this.state.gcNameList.length > 0) {
            key = Math.max.apply(Math, this.state.gcNameList.map(item => item.key)) + 1;
        }
        if (key <= this.MAX_ROWS) {
            const listItem = {
                key,
                text: ''
            };
            const gcNameListCopy = [...this.state.gcNameList];
            gcNameListCopy.push(listItem);
            this.setState({ gcNameList: gcNameListCopy });
        }
    }

    deleteListRow(key) {
        const { gcNameList } = this.state;
        const updatedGCNameList = gcNameList.filter(item => item.key !== key);
        this.setState({ gcNameList: updatedGCNameList });
        if (updatedGCNameList.length === 0) {
            this.props.onBlurHandler({
                u658ContractorName: ''
            });
        }
    }

    render() {
        if (!constants.VALID_BASE_COVERAGES.includes(this.props.coverage)) {
            return null;
        }
        const designatedGC = this.props.submission.ratings[this.type].designatedContractors;
        const { gcNameList = [] } = this.state;
        const enableGCU658AddBtn = () => {
            if (designatedGCCompleted(designatedGC) && gcNameList.length < this.MAX_ROWS) {
                return true;
            }
            return false;
        };
        let addButtonClass = 'fa fa-plus-circle fa-lg';
        if (!enableGCU658AddBtn()) {
            addButtonClass = `${addButtonClass} quoteAddBtnDisable`;
        }
        return (
            <div>
                <div className="list-header">
                    <h4 className="list-title">Contractor to be listed on U658-OI</h4>
                    <button
                        className="list-add"
                        onClick={this.addListRow}
                        disabled={!enableGCU658AddBtn()}
                    >
                        <i className={addButtonClass} title="Add List" aria-hidden="true" />
                    </button>
                </div>
                {gcNameList.map((item, index) => {
                    return (
                        <div key={item.key}>
                            <Row>
                                <Col xs={8} md={6}>
                                    <div className="premiumGrid">
                                        <span className="h4 list-input">
                                            <FormControl
                                                autoComplete={true}
                                                id={`u658GCName-${item.key}`}
                                                type="text"
                                                componentClass="input"
                                                defaultValue={item.text}
                                                onBlur={event =>
                                                    this.onBlurHandler(event, item.key)
                                                }
                                                placeholder={
                                                    this.props.placeholder
                                                        ? this.props.placeholder
                                                        : ''
                                                }
                                            />
                                        </span>
                                    </div>
                                </Col>
                                <Col>
                                    {index >= 0 && (
                                        <Button
                                            className="list-minus"
                                            onClick={() => this.deleteListRow(item.key)}
                                        >
                                            <i
                                                className="fa fa-minus-circle fa-lg"
                                                title="Delete List"
                                                aria-hidden="true"
                                            />
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </div>
        );
    }
}

const designatedGCCompleted = designatedGC => {
    if (Array.isArray(designatedGC)) {
        for (let i = 0; i < designatedGC.length; i += 1) {
            if (designatedGC[i].completed === false) {
                return false;
            }
        }
    }
    return true;
};

const setGCNameList = (ratingValues, coverage, type) => {
    const gcNameArray = [];

    if (
        designatedGCNameIsApplicable(ratingValues, coverage, type) &&
        typeof ratingValues.u658ContractorName === 'string' &&
        ratingValues.u658ContractorName.length > 0
    ) {
        gcNameArray.push({
            key: 1,
            text: ratingValues.u658ContractorName
        });
    }
    return gcNameArray;
};

export const designatedGCNameIsApplicable = (ratingValues, coverage, type) => {
    if (
        type !== constants.OI_TYPE ||
        !designatedGCCompleted(ratingValues.designatedContractors) ||
        !constants.VALID_BASE_COVERAGES.includes(coverage)
    ) {
        return false;
    }
    return true;
};

/**
 * This function will verify if Designated Contractors Name data is applicable and
 * return the updated Designated Contractors name.
 *
 * @param {Object} ratingValues
 * @param {string} coverage
 * @param {string} type

 */
export const getU658DesignatedContractorsName = (ratingValues, baseCoverage, type) => {
    let u658GCName = '';
    if (
        ratingValues.u658ContractorName !== undefined &&
        designatedGCNameIsApplicable(ratingValues, baseCoverage, type)
    ) {
        u658GCName = ratingValues.u658ContractorName;
    }
    return u658GCName;
};
